import * as React from 'react';
import { Provider } from 'react-redux';
import { ErrorLogComponent } from '@cian/error-log-component';
import { uaToDeviceType } from '@cian/ui-kit/utils';
import { Provider as MicrofrontendProvider } from '@cian/mf-react';
import { NewbuildingCallbackWidgetProvider } from '../NewbuildingCallbackWidgetProvider';
import { TReduxStore } from '../../types/redux';
import { IApplicationContext } from '../../types/applicationContext';
import { ApplicationContext } from '../../utils';
import { AdfoxPixelContainer } from '../AdfoxPixel';
import { PageContainer } from '../Page';
import { UiKitRoot } from '@cian/ui-kit';

export interface IApplicationProps {
  applicationContext: IApplicationContext;
  reduxStore: TReduxStore;
}

export function Application(props: IApplicationProps) {
  const { reduxStore, applicationContext } = props;
  const { logger, microfrontendsRegistry, custom } = applicationContext;

  return (
    <ErrorLogComponent logger={logger}>
      <ApplicationContext.Provider value={applicationContext}>
        <UiKitRoot deviceType={uaToDeviceType(custom.userAgent)}>
          <Provider store={reduxStore}>
            <MicrofrontendProvider registry={microfrontendsRegistry}>
              <NewbuildingCallbackWidgetProvider>
                <PageContainer />
                <AdfoxPixelContainer />
              </NewbuildingCallbackWidgetProvider>
            </MicrofrontendProvider>
          </Provider>
        </UiKitRoot>
      </ApplicationContext.Provider>
    </ErrorLogComponent>
  );
}
